import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  mode:'history',
  routes: [

      // PC端界面
      {path: '/',name: 'home',component: () => import('./views/Home/index.vue'), meta: {title: '科欣医药'}},

      {path: '/selectaddress',name: 'selectaddress',component: () => import('./views/Home/selectaddress.vue'), meta: {title: '地区选择'}}, 

      {path: '/user/login',name: 'user_login',component: () => import('./views/Home/login.vue'), meta: {title: '用户登录'}},
      {path: '/user/loginwechat',name: 'user_login1',component: () => import('./views/Home/login1.vue'), meta: {title: '绑定账号'}},
      {path: '/user/register',name: 'user_register',component: () => import('./views/Home/register.vue'), meta: {title: '用户注册'}},
      {path: '/user/forget_password',name: 'user_forget_password',component: () => import('./views/Home/forget_password.vue'), meta: {title: '忘记密码'}}, // 忘记密码


      {path: '/dzfp',name: 'dzfp',component: () => import('./views/Home/dzfp.vue'), meta: {title: '电子发票'}},
      {path: '/down',name: 'yjbg',component: () => import('./views/Home/yjbg.vue'), meta: {title: '文件下载'}},
      {path: '/zcpj',name: 'zcpj',component: () => import('./views/Home/zcpj.vue'), meta: {title: '注册批件'}},
      {path: '/wts',name: 'wts',component: () => import('./views/Home/wts.vue'), meta: {title: '委托书'}},

      // 产品列表
        // {path: '/goods/',name: 'goods_index',component: () => import('./views/Home/goods/index.vue'), meta: {title: '商品列表'}},

      // 产品列表
      {path: '/goods/params/',name: 'goods_index',component: () => import('./views/Home/goods/index.vue'), meta: {title: '商品列表'}},

      //产品搜素
       //{path: '/goods/search:info',name: 'goods_search',component: () => import('./views/Home/goods/search.vue')},
       {path: '/goods/params/:info',name: 'goods_search',component: () => import('./views/Home/goods/search.vue'), meta: {title: '商品搜索'}},
      // 产品详情
      {path: '/goods/info/:goods_id',name: 'home_goods_info',component: () => import('./views/Home/goods/info.vue'), meta: {title: '商品详情'}},

      //新闻列表
      {path: '/news/:info',name: 'news',component: () => import('./views/Home/news/index.vue'), meta: {title: '新闻列表'}},
      {path: '/news/',name: 'news_index',component: () => import('./views/Home/news/index.vue'), meta: {title: '新闻列表'}},
      //新闻详情
      {path: '/news/info/:info',name: 'news_info',component: () => import('./views/Home/news/info.vue'), meta: {title: '新闻详情'}},


      //底部文章
      //{path: '/article/:info',name: 'article_index',component: () => import('./views/Home/article/index.vue'), meta: {title: '帮助中心'}},
      {path: '/article/',name: 'article_index',component: () => import('./views/Home/article/index.vue'), meta: {title: '帮助中心'}},
      //文章详情
      {path: '/article/info/:info',name: 'article_info',component: () => import('./views/Home/article/info.vue'), meta: {title: '文章详情'}},


      //优惠券
      {path: '/coupon/',name: 'coupon_index',component: () => import('./views/Home/coupon/index.vue'), meta: {title: '优惠券'}},


      //转盘、九宫格抽奖
      {path: '/LuckyWheel/:info',name: 'LuckyWheel_index',component: () => import('./views/Home/LuckyWheel/index.vue'), meta: {title: '幸运抽奖'}},

      // 秒杀列表
      {path: '/goods/seckill',name: 'goods_seckill',component: () => import('./views/Home/goods/seckill.vue'), meta: {title: '限时秒杀'}},

      {path: '/user/bill_of_parcels_Details',name: 'home_bill_of_parcels_Details',component: () => import('./views/Home/user/bill_of_parcels_Details.vue'), meta: {title: '销售(随货同行)单', noCache: true,  affix: true}}, 
      {path: '/user/LP_xsdcx_Details',name: 'home_LP_xsdcx_Details',component: () => import('./views/Home/user/LP_xsdcx_Details.vue'), meta: {title: '两票_销售单', noCache: true,  affix: true}}, 



      // 用户中心
      {path: '/user/index',name: 'user_index',component: () => import('./views/Home/user/index.vue'),children:[
        {path: '/user/index',name: 'user_default',component: () => import('./views/Home/user/order.vue'), meta: {title: '会员中心'}},
        {path: '/user/address',name: 'user_address',component: () => import('./views/Home/user/address.vue'), meta: {title: '收货地址'}},
        {path: '/user/order',name: 'user_order',component: () => import('./views/Home/user/order.vue'), meta: {title: '我的订单'}},
        {path: '/user/order_info',name: 'user_order_info',component: () => import('./views/Home/user/order_info.vue'), meta: {title: '订单详情'}},   //订单详情
        {path: '/user/user_info',name: 'home_user_info',component: () => import('./views/Home/user/user_info.vue'), meta: {title: '账户信息'}}, 
        {path: '/user/user_info_company',name: 'home_user_info_company',component: () => import('./views/Home/user/user_info_company.vue'), meta: {title: '往来单位'}},  // 往来单位
        {path: '/user/user_form_company',name: 'home_user_form_company',component: () => import('./views/Home/user/user_form_company.vue'), meta: {title: '编辑单位'}},  // 添加修改往来单位
        {path: '/user/user_info_companyzz',name: 'home_user_info_companyzz',component: () => import('./views/Home/user/user_info_companyzz.vue'), meta: {title: '公司资质'}},  // 公司资质
        {path: '/user/user_form_companyzz',name: 'home_user_form_companyzz',component: () => import('./views/Home/user/user_form_companyzz.vue'), meta: {title: '编辑资质'}},  // 添加修改公司资质
        {path: '/user/fav',name: 'home_fav',component: () => import('./views/Home/user/fav.vue'), meta: {title: '我的收藏'}}, // 收藏关注
        {path: '/user/fav_store',name: 'home_fav_store',component: () => import('./views/Home/user/fav_store.vue')}, // 收藏关注
        {path: '/user/get_money_log/money',name: 'home_get_money_log',component: () => import('./views/Home/user/log.vue'), meta: {title: '我的余额'}}, // 资金变更日志
        {path: '/user/redbag',name: 'home_get_redbag',component: () => import('./views/Home/user/log_1.vue'), meta: {title: '我的红包'}}, // 资金变更日志
        {path: '/user/luckDraw',name: 'luckDraw',component: () => import('./views/Home/user/luck.vue'), meta: {title: '中奖纪录'}}, // 中奖纪录
        {path: '/user/get_money_log/freeze_money',name: 'home_get_money_log1',component: () => import('./views/Home/user/log_1.vue')}, // 资金变更日志
        {path: '/user/get_money_log/integral',name: 'home_get_money_log2',component: () => import('./views/Home/user/log_2.vue')}, // 资金变更日志
        {path: '/user/safe',name: 'home_user_safe',component: () => import('./views/Home/user/safe.vue'), meta: {title: '修改账户'}}, // 账号安全
        {path: '/user/coupon',name: 'home_user_coupon',component: () => import('./views/Home/user/coupon.vue'), meta: {title: '我的优惠券'}}, // 我的优惠券
        {path: '/user/quehuo',name: 'home_user_quehuo',component: () => import('./views/Home/user/user_qh.vue'), meta: {title: '缺货登记'}}, // 缺货登记
        {path: '/user/bug',name: 'home_bug',component: () => import('./views/Home/user/bug.vue'), meta: {title: 'BUG提交'}}, // BUG提交
        {path: '/user/message',name: 'home_message',component: () => import('./views/Home/user/message.vue'), meta: {title: '投诉建议'}}, // 投诉建议


        {path: '/user/bill_of_parcels',name: 'home_bill_of_parcels',component: () => import('./views/Home/user/bill_of_parcels.vue'), meta: {title: '销售(随货同行)单', noCache: true,  affix: true}}, 

        
        {path: '/user/LP_xsdcx',name: 'home_LP_xsdcx',component: () => import('./views/Home/user/LP_xsdcx.vue'), meta: {title: '两票_销售单查询', noCache: true,  affix: true}}, 
       
        

        



        {path: '/user/safe/password',name: 'home_user_safe_password',component: () => import('./views/Home/user/safe/password.vue'), meta: {title: '修改密码'}}, // 密码修改
        {path: '/user/BankAccount',name: 'home_user_BankAccount',component: () => import('./views/Home/user/BankAccount.vue'), meta: {title: '我的银行卡'}}, // 付款账户

        {path: '/user/purchase',name: 'home_user_purchase',component: () => import('./views/Home/user/user_purchase.vue'), meta: {title: '上传采购单'}}, // 我的采购单

        {path: '/user/user_bind',name: 'home_user_bind',component: () => import('./views/Home/user/user_bind.vue')}, // 账号绑定
        {path: '/user/safe/card',name: 'home_user_card',component: () => import('./views/Home/user/safe/card.vue')}, // 身份认证
        {path: '/user/selectcity',name: 'home_selectcity',component: () => import('./views/Home/user/selectcity.vue')}, // 省市

        // 评论列表
        {path: '/user/comment/add/:order_id',name: 'home_comment_add',component: () => import('./views/Home/user/comment/add.vue')}, // 订单添加评论
        {path: '/user/comment/index',name: 'home_comment_index',component: () => import('./views/Home/user/comment/index.vue')}, // 订单添加评论

        // 分销信息
        {path: '/user/inviter/inviter_info',name: 'home_inviter_info',component: () => import('./views/Home/user/inviter/inviter_info.vue'), meta: {title: '我的推广'}}, 
        {path: '/user/inviter/inviter_member',name: 'home_inviter_member',component: () => import('./views/Home/user/inviter/inviter_member.vue')}, 
        {path: '/user/inviter/inviter_money',name: 'home_inviter_money',component: () => import('./views/Home/user/inviter/inviter_money.vue')}, 

        // 积分订单
        {path: '/user/integral_order',name: 'integral_order',component: () => import('./views/Home/user/integral_order.vue')},

        //聊天记录
        {path: '/user/chat_history',name: 'chatHistory',component: () => import('./views/Home/user/chat_history.vue')},
        

        // 提现列表页面
        {path: '/user/cash/index',name: 'home_cash_index',component: () => import('./views/Home/user/cash/index.vue')}, 
      ]},


      // 购物车
      {path: '/cart/index',name: 'cart_index',component: () => import('./views/Home/cart/index.vue'), meta: {title: '购物车'}},
      {path: '/cart/index2',name: 'cart_index2',component: () => import('./views/Home/cart/index2.vue'), meta: {title: '购物车'}},

      // 生成订单页面  或者选择物流地址
      {path: '/order/create_order/:type/:info',name: 'create_order_index',component: () => import('./views/Home/order/create_order.vue'), meta: {title: '创建订单'}},  
      {path: '/order/chose_pay/:info',name: 'home_chose_pay',component: () => import('./views/Home/order/chose_pay.vue'), meta: {title: '支付订单'}},  
      {path: '/order/pay_success',name: 'home_pay_success',component: () => import('./views/Home/order/pay_success.vue'), meta: {title: '支付成功'}},  

      // 积分商城
      {path: '/integral/index',name: 'home_integral_index',component: () => import('./views/Home/integral/index.vue')},  
      {path: '/integral/goods/index/:info',name: 'home_integral_goods_index',component: () => import('./views/Home/integral/goods/index.vue')},  
      {path: '/integral/goods/info/:id',name: 'home_integral_goods_info',component: () => import('./views/Home/integral/goods/info.vue')},  

      // 积分商城订单
      {path: '/integral/order/create_order/:info',name: 'home_integral_order_create_order',component: () => import('./views/Home/integral/order/create_order.vue')},  
      {path: '/integral/order/pay_success',name: 'home_integral_order_pay_success',component: () => import('./views/Home/integral/order/pay_success.vue')},   // 积分兑换成功

      // 拼团商品列表页面
      {path: '/groupbuy',name: 'home_groupbuy_list',component: () => import('./views/Home/goods/groupbuy.vue'), meta: {title: '团购'}}, 
      
      
      // 专题列表
      {path: '/special/',name: 'special',component: () => import('./views/Home/special/index.vue'), meta: {title: '专题列表'}},
      {path: '/special/tcm',name: 'tcm',component: () => import('./views/Home/special/goods/tcm.vue'), meta: {title: '中药列表'}},
      {path: '/special/list/:info/',name: 'special_goods',component: () => import('./views/Home/special/goods/index.vue'), meta: {title: '专题页'}}, 
      {path: '/special/combo',name: 'combo',component: () => import('./views/Home/special/goods/combo.vue'), meta: {title: '套餐列表'}},
      // {path: '/groupbuy',name: 'groupbuy',component: () => import('./views/Home/special/goods/combo.vue'), meta: {title: '团购列表'}},
      {path: '/event/gather',name: 'gather',component: () => import('./views/Home/special/gather.vue'), meta: {title: '活动集合'}},
      {path: '/event/list/:info/',name: 'event_goods',component: () => import('./views/Home/special/goods/event.vue'), meta: {title: '活动页'}},
      {path: '/51bencao',name: '51bencao',component: () => import('./views/Home/51bencao.vue'), meta: {title: '芸欣医药'}},



       //精品控销
      {path: '/control/',name: 'control_goods',component: () => import('./views/Home/control/index.vue'), meta: {title: '精品控销'}}, 

       //跳转后台
      {path: '/admin/',name: 'admin',component: () => import('./views/Home/admin.vue'), meta: {title: '后台管理'}}, 

       //404
      {path: '/404/',name: '404',component: () => import('./views/Home/404.vue'), meta: {title: '系统升级维护中'}}, 

      {path: '*', redirect: '/'},
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
